<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 800px; height: 800px;" data-cy="appointment-procedure-dialog">
  @if (casesLoading) {
    <div class="spinner-container" data-cy="appointment-procedure-spinner">
      <mat-spinner data-cy="appointment-procedure-progress"></mat-spinner>
    </div>
  }
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="appointment-procedure-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="appointment-procedure-header">
      <div class="section-header-title" data-cy="appointment-procedure-title">
        Select procedure / case for appointment
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow: hidden;" data-cy="appointment-procedure-content">
      <div style="display: flex; flex-direction: column; overflow: hidden;" data-cy="appointment-procedure-container">
        <div style="flex-basis: 40px; display: flex;" data-cy="appointment-procedure-tabs-container">
          <mat-tab-group (focusin)="onTabGroupFocusIn($event)" (focusChange)="onTabGroupFocusChange($event)" #tabGroup tabindex="-1" (selectedTabChange)="onTabChange($event)" data-cy="appointment-procedure-tabs">
            <mat-tab #me (focusin)="onAppointmentsFocusIn($event)" tabindex="0" label="New Case" data-cy="appointment-procedure-new-case-tab"></mat-tab>
            <mat-tab tabindex="1" label="Existing Case" data-cy="appointment-procedure-existing-case-tab"></mat-tab>
          </mat-tab-group>
        </div>
        <div class="appointments" #appointmentsDiv style="flex: 1; overflow: hidden; margin-top: 2px;" data-cy="appointment-procedure-appointments">


          @if (type === 'appointment') {
            <div tabindex="1" style="height: 640px; overflow: hidden;" data-cy="appointment-procedure-procedures-list-container">
              <tdo-list #tdoListProcedures [dataSource]="data.procedures"
                [isRequireFocus]="false"
                propertyName="ProcedureName"
                height="640px"
                (onItemSelected)="onProcedureSelectionChange($event)"
                data-cy="appointment-procedure-procedures-list">
              </tdo-list>
            </div>
          }


          @if (type === 'case') {
            <div style="height: 100%; display: flex; flex-direction: column; overflow-y: hidden;" data-cy="appointment-procedure-case-container">
              <div style="flex: 1; display: flex; flex-direction: column; overflow-y: hidden;" data-cy="appointment-procedure-cases-section">
                <div style="font-weight: 500; font-size: 16px; color: var(--tdo-primary-accent);" data-cy="appointment-procedure-cases-title">Step 1: Select one of Current cases</div>
                <div style="display: flex; font-weight: 500; font-size: 14px;" data-cy="appointment-procedure-cases-header">
                  <div style="flex: 1;" data-cy="appointment-procedure-cases-teeth-header">Teeth</div>
                  <div style="flex: 1;" data-cy="appointment-procedure-cases-description-header">Description</div>
                  <div style="flex: 1;" data-cy="appointment-procedure-cases-status-header">Status</div>
                  <div style="flex: 1;" data-cy="appointment-procedure-cases-date-header">Status Date</div>
                </div>
                <div style="flex: 1; max-height: 300px; overflow-y: auto;" data-cy="appointment-procedure-cases-list">
                  @for (cse of data.patientCases; track cse) {
                    <div (click)="onSelectedCase(cse)" data-cy="appointment-procedure-case-item">
                      <div style="display: flex;" class="scheduler-procedure-item" [ngClass]="{'scheduler-procedure-item-selected': isProcedureSelected(cse)}" data-cy="appointment-procedure-case-row">
                        <div style="flex: 1;" data-cy="appointment-procedure-case-teeth">{{cse.Teeth}}</div>
                        <div style="flex: 1;" data-cy="appointment-procedure-case-description">{{cse.Description}}</div>
                        <div style="flex: 1;" data-cy="appointment-procedure-case-status">{{cse.Status}}</div>
                        <div style="flex: 1;" data-cy="appointment-procedure-case-date">{{(cse.StatusDate !== null) ? (cse.StatusDate  + 'Z' | date: 'short') : "" }}</div>
                      </div>
                      @for (cse1 of cse.Case.ChildCases; track cse1) {
                        <div (click)="onSelectedCase(cse1); $event.stopPropagation(); false;" style="margin-left: 6px; color: black; margin-top: 1px;" data-cy="appointment-procedure-child-case-item">
                          <div style="display: flex;" class="scheduler-child-procedure-item" [ngClass]="{'scheduler-child-procedure-item-selected': isProcedureSelected(cse1)}" data-cy="appointment-procedure-child-case-row">
                            <div style="flex: 1;" data-cy="appointment-procedure-child-case-teeth">{{cse1.Teeth}}</div>
                            <div style="flex: 1;" data-cy="appointment-procedure-child-case-description">{{cse1.Description}}</div>
                            <div style="flex: 1;" data-cy="appointment-procedure-child-case-status">{{cse1.Status}}</div>
                            <div style="flex: 1;" data-cy="appointment-procedure-child-case-date">{{(cse1.StatusDate !== null) ? (cse1.StatusDate  + 'Z' | date: 'short') : "" }}</div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div style="flex: 1; display: flex; flex-direction: column; overflow-y: hidden;" data-cy="appointment-procedure-case-procedures-section">
                <div style="font-weight: 500; font-size: 16px; margin-top: 10px; color: var(--tdo-primary-accent);" data-cy="appointment-procedure-case-procedures-title">Step 2: Select a Procedure</div>
                <div style="flex: 1; max-height: 100%; overflow-y: auto;" data-cy="appointment-procedure-case-procedures-list">
                  @for (proc of selectedPatientCaseProcedures; track proc) {
                    <div class="scheduler-procedure-item" (click)="onCaseProcedureSelected(proc)" data-cy="appointment-procedure-case-procedure-item">
                      <div style="display: flex;" data-cy="appointment-procedure-case-procedure-row">
                        <div style="flex-basis: 60px;" data-cy="appointment-procedure-case-procedure-code">{{proc.procedure.Code}}</div>
                        <div style="flex: 1;" data-cy="appointment-procedure-case-procedure-name">{{proc.procedure.ProcedureName}}</div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="appointment-procedure-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="appointment-procedure-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="appointment-procedure-ok-button">Ok</button>
    </div>
  </div>
</div>
